const Hide = 'hide';
const Show = 'show';
export class Observer {
  container: HTMLElement;
  onShow?: Function;
  onHide?: Function;
  status = Hide;
  constructor(el: HTMLElement, onShow?: Function, onHide?: Function) {
    this.container = el;
    this.onShow = onShow;
    this.onHide = onHide;
  }
  observe(el: HTMLElement) {
    this.scrollHandle = this.scrollHandle.bind(this, el);
    if (this.container.scrollTop > el.offsetTop + el.offsetHeight) {
      this.status = Hide;
    } else {
      this.status = Show;
    }
    this.container.addEventListener('scroll', this.scrollHandle as any);
  }
  scrollHandle(el: HTMLElement) {
    const hideTop = el.offsetTop + el.offsetHeight;
    const showTop = el.offsetTop;
    const scrollTop = this.container.scrollTop;
    if (this.container.scrollTop > hideTop) {
      this.callHide();
    } else if (scrollTop < showTop) {
      this.callShow();
    }
  }
  callHide() {
    if (this.status !== Hide) {
      this.status = Hide;
      this.onHide && this.onHide();
    }
  }
  callShow() {
    if (this.status !== Show) {
      this.status = Show;
      this.onShow && this.onShow();
    }
  }
  unobserve() {
    this.container.removeEventListener('scroll', this.scrollHandle as any);
  }
}

export default Observer;
